<template>
  <div class="sibiling-color">
    <no-ssr>
      <overlay-scrollbars :options="{ scrollbars: { visibility: 'h' }, overflowBehavior: {y: 'hidden', x: 'scroll'} }" ref="sibling-scrollbar">
        <div class="color-list">
          <div class="swatch-option" v-for="sibiling in siblingProducts" :key="sibiling.color" :class="{'active' : sibiling.color === colorSelected }" ref="swatch-opt" :data-active="sibiling.color === colorSelected">
            <div class="swatch-option__radio" :style="{'background': sibiling.color_image }" @click.prevent="change(sibiling)"></div>
          </div>
        </div>
      </overlay-scrollbars>
    </no-ssr>
  </div>
</template>

<script>
import sortBy from 'lodash/sortBy'

export default {
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    product: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    siblingProducts () {
      // create array
      let siblings = []
      const setColorImageHas = (colorImage) => {
        if (colorImage) {
          if (!['.jpg', '.png', '.svg'].includes(colorImage) && colorImage.includes('#')) {
            // is esedecimal
            return colorImage.slice(colorImage.indexOf('#'))
          } else {
            return `center / contain no-repeat url(${colorImage})`
          }
        } else {
          return ''
        }
      }
      if (this.product.sibling_products) {
        siblings = this.product.sibling_products.map((el) => {
          return {
            ...el,
            color_image: setColorImageHas(el.color_image)
          }
        })
      }
      siblings.push({
        color: this.colorSelected,
        color_image: setColorImageHas(this.product.image.url),
        color_label: this.product.color_label || '',
        url_key: this.product.url_key,
        url_suffix: this.product.url_suffix
      })

      return sortBy(siblings, ['url_key'])
    },
    colorSelected () {
      return this.product.color || ''
    }
  },
  methods: {
    change (sibiling) {
      // const _this = this
      const finishPath = sibiling.url_key + sibiling.url_suffix
      let beforePath = ''
      if (this.$store.state.cms.currentComponent === 'ProductPage') {
        beforePath = this.$route.fullPath
        beforePath = beforePath.substr(0, beforePath.lastIndexOf('/') + 1)
        this.$router.push(beforePath + finishPath)
      }
      this.$emit('siblingChange', sibiling)
    },
    scrollToActive () {
      this.$nextTick(() => {
        let elements = this.$refs['swatch-opt']
        let tagsScollbar = this.$refs['sibling-scrollbar']
        if (tagsScollbar) {
          tagsScollbar = tagsScollbar.osInstance()
          let element = elements.find((el) => el.dataset.active) || elements[0]
          tagsScollbar.scroll({ el: element, scroll: 'ifneeded', block: ['begin', 'end'], margin: 75 })
        }
      })
    }
  },
  mounted () {
    this.scrollToActive()
  }
}
</script>
